import { render, staticRenderFns } from "./log-remote.vue?vue&type=template&id=1bd6322f&scoped=true&lang=pug&"
import script from "./log-remote.vue?vue&type=script&lang=js&"
export * from "./log-remote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd6322f",
  null
  
)

export default component.exports